var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgPin32 = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m13.174 16.994-5.098 6.372a1 1 0 0 0 .074 1.332l.149.149a1 1 0 0 0 1.331.073l6.373-5.097m5.643-3.921 4.511-2.506a1 1 0 0 0 .222-1.582l-5.196-5.196a1 1 0 0 0-1.582.221l-2.488 4.48c-.234.42-.733.608-1.203.504-2.526-.56-4.468.35-5.484 1.022-.46.304-.47.93-.08 1.32l8.579 8.58c.352.352.905.381 1.211-.011.684-.877 1.634-2.707 1.008-5.675-.095-.454.096-.932.502-1.157"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPin32);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };